namespace TabAurous.Finance {
    export namespace AccountReceivableService {
        export const baseUrl = 'Finance/AccountReceivable';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PartyBalanceRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Finance/AccountReceivable/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>AccountReceivableService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
